import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { ReactNode } from 'react';

interface GradientTextProps {
  children: ReactNode;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    gradient: {
      background: theme.palette.gradient.main,
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent'
    }
  })
);

export default function GradientText({ children }: GradientTextProps) {
  const classes = useStyles();

  return <span className={classes.gradient}>{children}</span>;
}
